import { delay, SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { suggestFetch } from 'src/sagas/suggestFetch';
import { SUGGEST_ACTIONS, SuggestRequest } from 'src/actions/SuggestActions';
import { getIsQueryChanged } from 'src/selectors/getIsQueryChanged';
import { getSuggestData } from 'src/selectors/getSuggestData';
import { SuggestData } from 'src/state/SuggestState';

export function* suggestSaga({ meta: query }: SuggestRequest): SagaIterator {
    try {
        yield put(SUGGEST_ACTIONS.pending(query));
        yield call(delay, 100);

        if (!query) {
            yield put(SUGGEST_ACTIONS.success([], query));
            return;
        }

        const isChanged: boolean = yield select(getIsQueryChanged, query);
        if (!isChanged) {
            const currentResult: SuggestData = yield select(getSuggestData);
            yield put(SUGGEST_ACTIONS.success(currentResult, query));
            return;
        }

        const suggests = yield call(suggestFetch, query);
        yield put(SUGGEST_ACTIONS.success(suggests, query));
    } catch (error) {
        yield put(SUGGEST_ACTIONS.failure(error, query));
    }
}
